module.exports = __webpack_public_path__ + "img/course (2).da284c22.png";